'use strict';

var sleeknote = sleeknote || {};

sleeknote.slideshow = sleeknote.slideshow || function () {

    function init() {
        slideshowGallery();
    }

    function slideshowGallery(){

        $(document).ready(function(){


            // Block slideshow gallery

            if($('.js-slideshow').length){ // do the page have a gallery?

                $('.js-slideshow').each(function(){ // in case there's multiple galleries

                    var thisGallery = $(this);

                    thisGallery.flickity({
                        cellAlign: 'left',
                        contain: true,
                        lazyLoad: true,
                        pageDots: false,
                        prevNextButtons: false,
                        adaptiveHeight: true,
                        imagesLoaded: true
                    });

                    var thisGalleryData = thisGallery.data('flickity'),
                        thisGalleryControls = thisGallery.siblings('.js-slideshow-controls'),
                        thisGalleryPrev = thisGalleryControls.find('button.slideshow-prev'),
                        thisGalleryNext = thisGalleryControls.find('button.slideshow-next'),
                        thisGalleryCurrentNum = thisGalleryControls.find('.gallery-index-current'),
                        thisGalleryTotalNum = thisGalleryControls.find('.gallery-index-total');

                    thisGalleryNext.on('click', function(e){
                        thisGallery.flickity('next');
                        updateIndex();
                    });

                    thisGalleryPrev.on('click', function(e){
                        thisGallery.flickity('previous');
                        updateIndex();
                    });
    
                    function updateIndex(){
                        thisGalleryControls.addClass('show');
                        if ( thisGalleryCurrentNum ) thisGalleryCurrentNum.text(thisGalleryData.selectedIndex +1);
                        if ( thisGalleryTotalNum ) thisGalleryTotalNum.text(thisGalleryData.cells.length);

                        if( thisGalleryData.selectedIndex === 0 ){
                            thisGalleryPrev.addClass('disabled');
                        } else {
                            thisGalleryPrev.removeClass('disabled');
                        }
                        if( thisGalleryData.selectedIndex +1 === thisGalleryData.cells.length ){
                            thisGalleryNext.addClass('disabled');
                        } else {
                            thisGalleryNext.removeClass('disabled');
                        }

                    }

                    updateIndex();

                    thisGallery.on( 'change.flickity', function( event, index ) {
                        updateIndex();
                    });

                });

            }

            // Productpage header gallery

            if($('.product-page-gallery').length){ 

                $('.product-page-gallery').each(function(){ 

                    var thisGallery = $(this);

                    thisGallery.flickity({
                        cellAlign: 'left',
                        contain: true,
                        lazyLoad: true,
                        pageDots: true,
                        prevNextButtons: false,
                        adaptiveHeight: false,
                        imagesLoaded: true
                    });

                });
            }

            // Testimonial slider

            if($('.block-testimonial-slider').length){

                $('.testimonial-slider-container').each(function(){

                    var thisGallery = $(this);

                    thisGallery.flickity({
                        cellAlign: 'left',
                        contain: true,
                        lazyLoad: true,
                        pageDots: false,
                        prevNextButtons: true,
                        adaptiveHeight: false,
                        imagesLoaded: true,
                        autoPlay: 3500,
                    });

                });

            }

            if($('#logowall-logos-js').length){
                if ( matchMedia('screen and (max-width: 767px)').matches ) {

                    $('#logowall-logos-js').flickity({
                        cellAlign: 'left',
                        lazyLoad: true,
                        pageDots: false,
                        prevNextButtons: false,
                        adaptiveHeight: false,
                        imagesLoaded: true,
                        freeScroll: true,
                        percentPosition: false
                    });
                    
                }
            }

            if( $('.block-quotes-slider').length ) {
                $('.quotes-slider').each(function() {

                    var thisGallery = $(this);

                    thisGallery.flickity({
                        cellAlign: 'left',
                        contain: true,
                        lazyLoad: true,
                        pageDots: false,
                        prevNextButtons: false,
                        adaptiveHeight: true,
                        imagesLoaded: true,
                        autoPlay: true
                    });


                    var thisGalleryData = thisGallery.data('flickity'),
                        thisGalleryControls = thisGallery.siblings('.quotes-slider-controls'),
                        thisGalleryPrev = thisGalleryControls.find('button.slideshow-prev'),
                        thisGalleryNext = thisGalleryControls.find('button.slideshow-next');

                    thisGalleryNext.on('click', function(e){
                        thisGallery.flickity('next');
                        updateIndex();
                    });

                    thisGalleryPrev.on('click', function(e){
                        thisGallery.flickity('previous');
                        updateIndex();
                    });
                    
                    function updateIndex(){
                        thisGalleryControls.addClass('show');

                        if( thisGalleryData.selectedIndex === 0 ){
                            thisGalleryPrev.addClass('disabled');
                        } else {
                            thisGalleryPrev.removeClass('disabled');
                        }
                        if( thisGalleryData.selectedIndex +1 === thisGalleryData.cells.length ){
                            thisGalleryNext.addClass('disabled');
                        } else {
                            thisGalleryNext.removeClass('disabled');
                        }

                    }

                    updateIndex();

                    thisGallery.on( 'change.flickity', function( event, index ) {
                        updateIndex();
                    });

                });
            }


        });

    }


    return {
        init:init
    };


}();